import React, { PureComponent } from "react";
import { Helmet } from "react-helmet";


import List from "../../../../../Components/List/List";
import ContainerHeader from "../../../../../Components/ContainerHeader";
import Navbar from "../../Navbar";
import localize from "helpers/localize";
class ExamsList extends PureComponent {
  render() {
    return (
      <div className="animated slideInUpTiny animation-duration-3">
        <Helmet>
          <title>{localize("exams", "Vizsga kérdések")}</title>
        </Helmet>
        <Navbar />
        <ContainerHeader title={localize("exams", "Vizsga kérdések")} />

        <List {...this.props} />
      </div>
    );
  }
}

export default ExamsList;
